import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import arrowIconUp from '../../images/arrow-icon-up.svg';
import styles from './Arrow.css';

const Arrow = ({ down, valueDescription }) => (
    <React.Fragment>
        <img
            className={cn('arrow-up-icon', {
                'down-arrow': down
            })}
            src={arrowIconUp}
            alt={
                down
                    ? `${valueDescription} down as of prior business day`
                    : `${valueDescription} up as of prior business day`
            }
        />
        <style jsx>{styles}</style>
    </React.Fragment>
);

Arrow.defaultProps = {
    down: true,
    valueDescription: ''
};

Arrow.propTypes = {
    down: PropTypes.bool,
    valueDescription: PropTypes.node
};

export default Arrow;
